import React, { useState } from 'react';

const DiscountBanner = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText('Pixelore');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <span 
      className="panel-button" 
      onClick={handleCopyCode}
      style={{ 
        cursor: 'pointer',
        position: 'relative',
        display: 'inline-block'
      }}
    >
      Use Code "Pixelore" for 5% Discount!
      {copied && (
        <span style={{
          position: 'absolute',
          top: '-25px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: '#333',
          color: '#fff',
          padding: '2px 8px',
          borderRadius: '4px',
          fontSize: '12px'
        }}>
          Copied!
        </span>
      )}
    </span>
  );
};

export default DiscountBanner;